import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-8 min-h-12 md:mt-2" }
const _hoisted_2 = { class: "text-3xl font-medium capitalize" }
const _hoisted_3 = { class: "flex flex-wrap w-full mt-6 space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_4 = { class: "flex w-full md:w-4/5" }
const _hoisted_5 = ["onKeydown"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_7 = { class: "w-full space-x-2 md:w-1/5" }
const _hoisted_8 = { class: "group" }
const _hoisted_9 = {
  key: 0,
  class: "fixed right-0 w-64 px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity -translate-x-3 bg-gray-800 rounded-md opacity-0 cursor-not-allowed group-hover:opacity-100"
}
const _hoisted_10 = { class: "w-full mt-6 table-auto" }
const _hoisted_11 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_15 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_16 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_17 = { class: "flex items-center px-2 py-2 space-x-3 whitespace-nowrap" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex items-center w-full mt-10" }
const _hoisted_21 = { class: "flex flex-wrap items-center justify-center mx-auto space-y-2 md:space-y-0" }
const _hoisted_22 = { class: "flex w-full md:w-1/2" }
const _hoisted_23 = { class: "flex w-full md:w-1/2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  class: "w-4",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
  })
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "w-4",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6" }, null, -1)

import { PropType, ref } from "vue";
import { storeToRefs } from "pinia";

import MoveStudentModal from "@/components/modals/MoveStudentModal.vue.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import RouterButton from "@/components/RouterButton.vue";
import RoleGuard from "@/components/RoleGuard.vue";

import api from "@/api/api";
import { userHasRole } from "@/utils/roles";
import { Club, PaginationMeta, Student } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClubParticipantTable',
  props: {
  club: {
    type: Object as PropType<Club>,
    required: true,
  },
},
  emits: ["delete"],
  async setup(__props, { emit: emits }) {

let __temp: any, __restore: any

const props = __props;

const globalStore = useGlobalStore();
const { user } = storeToRefs(useUserStore());

const isDeleteModalOpen = ref(false);
const isMovingParticipant = ref(false);
const isMoveStudentModalOpen = ref(false);

const page = ref(1);
const query = ref("");
const students = ref([] as Student[]);
const meta = ref({} as PaginationMeta);
const selectedStudent = ref("" as Student["id"]);





async function goToPage(p: number) {
  page.value = p;
  return await listStudents();
}

/** Remove Participants */
async function toggleRemoveModal(student_id: Student["id"]) {
  isDeleteModalOpen.value = true;
  selectedStudent.value = student_id;
}

async function removeStudentFromClub() {
  try {
    await api.clubs.removeStudentFromClub(props.club.id, selectedStudent.value);

    await listStudents();
    emits("delete");
    selectedStudent.value = "";
    isDeleteModalOpen.value = false;

    globalStore.toast("SUCCESS", "Student removed from Club");
  } catch (error) {
    console.log(error);
    globalStore.toast("SUCCESS", "Error removing Student from Club");
  }
}

/** Move Participant */
async function toggleMoveModal(student_id: Student["id"]) {
  isMoveStudentModalOpen.value = true;
  selectedStudent.value = student_id;
}

async function moveStudentFromClub(club_id: number) {
  try {
    isMovingParticipant.value = true;
    await api.clubs.removeStudentFromClub(props.club.id, selectedStudent.value);
    await api.clubs.addStudentToClub(club_id, selectedStudent.value);

    await listStudents();
    selectedStudent.value = "";
    isMoveStudentModalOpen.value = false;

    globalStore.toast("SUCCESS", "Student moved to new Club");
  } catch (error) {
    console.log(error);
    globalStore.toast("SUCCESS", "Error moving Student to Club");
  } finally {
    isMovingParticipant.value = false;
  }
}

/** Club Participants */
async function listStudents() {
  const response = await api.clubs.listClubStudents(page.value, props.club.id);
  students.value = response.data.students;
  meta.value = response.meta;
}

if (
  userHasRole(user.value.roles, [
    "advanced-facilitator",
    "admin",
    "trainer-organisation",
    "certified-facilitator",
    "facilitator-organisation",
    "clubs-admin",
    "advanced-facilitator-trainee",
  ])
) {
  (
  ([__temp,__restore] = _withAsyncContext(() => listStudents())),
  await __temp,
  __restore()
);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MoveStudentModal, {
      isOpen: isMoveStudentModalOpen.value,
      isSaving: isMovingParticipant.value,
      onMove: moveStudentFromClub,
      organisation: __props.club.organisation_id,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isMoveStudentModalOpen.value = false))
    }, null, 8, ["isOpen", "isSaving", "organisation"]),
    _createVNode(ConfirmationModal, {
      buttonText: _ctx.$t('remove-participant'),
      class: "danger",
      isOpen: isDeleteModalOpen.value,
      onDelete: removeStudentFromClub,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isDeleteModalOpen.value = false))
    }, null, 8, ["buttonText", "isOpen"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("club-members")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("club-members-helptext")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _withKeys(listStudents, ["enter"]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((query).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: "Search ...",
            required: ""
          }, null, 40, _hoisted_5), [
            [_vModelText, query.value]
          ]),
          _createElementVNode("button", {
            onClick: listStudents,
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r bg-primary hover:bg-blue-700"
          }, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(RoleGuard, { roles: ['admin', 'advanced-facilitator', 'advanced-facilitator-trainee', 'certified-facilitator', 'facilitator-organisation', 'clubs-admin'] }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(RouterButton, {
                  type: "primary",
                  class: "capitalize",
                  loading: false,
                  disabled: !__props.club.places_available,
                  to: { path: `/dashboard/clubs/${__props.club.id}/participants/new` }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("add-new-participant")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "to"]),
                (!__props.club.places_available)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("club-is-full")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("table", _hoisted_10, [
        _createElementVNode("thead", _hoisted_11, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("name")), 1),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("date-added")), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("actions")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(students.value, (student) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400",
              key: student.id
            }, [
              _createElementVNode("td", _hoisted_15, _toDisplayString(student.first_name) + _toDisplayString(student.middle_name ? ` ${student.middle_name}` : "") + " " + _toDisplayString(student.last_name), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(new Date(student.created_at).toDateString()), 1),
              _createElementVNode("td", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/clubs/${__props.club.id}/participants/${student.id}`,
                  class: "underline text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_component_router_link, {
                  to: `/dashboard/clubs/${__props.club.id}/participants/${student.id}/edit`,
                  class: "underline text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit")), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(RoleGuard, { roles: ['admin', 'clubs-admin', 'facilitator-organisation'] }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleMoveModal(student.id)),
                      class: "underline text-blue"
                    }, _toDisplayString(_ctx.$t("move")), 9, _hoisted_18)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleRemoveModal(student.id)),
                  class: "underline text-blue"
                }, _toDisplayString(_ctx.$t("remove")), 9, _hoisted_19)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("total-meta-pagination-total_entries-items", [meta.value.pagination?.total_entries])), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(page.value - 1))),
              class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-l text-blue", { 'pointer-events-none': page.value - 1 <= 0 }])
            }, _hoisted_25, 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meta.value.pagination?.total_pages, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                key: p,
                onClick: ($event: any) => (goToPage(p)),
                class: _normalizeClass([p === page.value ? 'text-white bg-primary' : 'text-blue bg-white', "px-4 py-2 list-none border border-gray-400"])
              }, _toDisplayString(p), 11, _hoisted_26))
            }), 128)),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(page.value + 1))),
              class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-r text-blue", { 'pointer-events-none': meta.value.pagination.total_pages < page.value + 1 }])
            }, _hoisted_28, 2)
          ])
        ])
      ]),
      _hoisted_29
    ])
  ], 64))
}
}

})